<template>
  <div class="employement_details">
    <b-list-group class="em_list">
      <h2 class="font-weight-bold mb-4">Employment details</h2>
      <b-list-group-item
        v-for="(list,index) in employList"
        :key="index"
        @click="handle_function_call(list.formCall)"
      >Call {{list.title}}</b-list-group-item>
    </b-list-group>
    <div v-show="showCall" class="em_form call-center">
      <b-link @click="closeCallForm">Back to select</b-link>
      <h2 class="font-weight-bold mb-4 mt-2">Call Center Employee</h2>
      <b-form-group label="Company Name" label-for="cname">
        <b-form-input id="cname" type="text" required placeholder="Name"></b-form-input>
      </b-form-group>
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Company Phone" label-for="cphone">
            <b-form-input id="cphone" type="number" required placeholder="Phone"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Amount of the monthly income" label-for="income">
            <b-form-input id="income" type="number" required placeholder="Income"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <h4 class="mt-4">References</h4>
      <p>You need to specify at least one reference to confirm your personality. You can also add more contacts in case you main reference is unavailable. For quick approval ensure that they are in touch.</p>
      <div id="ref_parent">
        <div class="reference" v-for="(item, index) in references" :key="index">
          <b-form-select required v-model="ref" :options="refOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <label for>Status:</label>
          <b-form-select required v-model="status" :options="statOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Name" :label-for="item.referenceNameId">
                <b-form-input :id="item.referenceNameId" type="text" required placeholder="Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Phone Number" :label-for="item.referencePhoneId">
                <b-form-input
                  :id="item.referencePhoneId"
                  type="number"
                  required
                  placeholder="Number"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-link class="addrel" @click="addRef()">
          <img src="@/assets/images/icons/plus.png" />Add relative or co-worker
        </b-link>
        <b-link class="addrel text-danger" @click="deleteRef">
          <img src="@/assets/images/icons/minus.png" />Delete relative or co-worker
        </b-link>
      </div>
      <p
        class="mt-4"
      >For quick approval, please ensure their availability after your complete your application.</p>
      <div class="d-flex justify-content-end mb-4 next mt-4">
        <button @click.prevent="$router.push('/registration/step-4')" type="submit">Next Step</button>
      </div>
    </div>
    <div v-show="showFree" class="em_form freelacer">
      <b-link @click="closeFreeForm">Back to select</b-link>
      <h2 class="font-weight-bold mb-4 mt-2">Freelancer / Self-employed / Business Owner</h2>
      <b-form-group label="Amount of the monthly income" label-for="freeincome">
        <b-form-input id="freeincome" type="number" required placeholder="Income"></b-form-input>
      </b-form-group>
      <h4 class="mt-4">References</h4>
      <p>You need to specify at least one reference to confirm your personality. You can also add more contacts in case you main reference is unavailable. For quick approval ensure that they are in touch.</p>
      <div id="ref_parent">
        <div class="reference">
          <b-form-select required v-model="ref" :options="refOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <label for>Status:</label>
          <b-form-select required v-model="status" :options="statOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Name" label-for="freename">
                <b-form-input id="freename" type="text" required placeholder="Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Phone Number" label-for="freenum">
                <b-form-input id="freenum" type="number" required placeholder="Number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-link class="addrel">
          <img src="@/assets/images/icons/plus.png" />Add relative or co-worker
        </b-link>
        <b-link class="addrel text-danger">
          <img src="@/assets/images/icons/minus.png" />Delete relative or co-worker
        </b-link>
      </div>
      <p
        class="mt-4"
      >For quick approval, please ensure their availability after your complete your application.</p>
      <div class="d-flex justify-content-end mb-4 next mt-4">
        <button @click.prevent="$router.push('/registration/step-4')" type="submit">Next Step</button>
      </div>
    </div>
    <div v-show="showGov" class="em_form g-employee">
      <b-link @click="closeGovForm">Back to select</b-link>
      <h2 class="font-weight-bold mb-4 mt-2">Government Employee</h2>
      <b-form-group label="Company Name" label-for="gcname">
        <b-form-input id="gcname" type="text" required placeholder="Name"></b-form-input>
      </b-form-group>
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Company Phone" label-for="gphone">
            <b-form-input id="gphone" type="number" required placeholder="Phone"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Amount of the monthly income" label-for="gincome">
            <b-form-input id="gincome" type="number" required placeholder="Income"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <h4 class="mt-4">References</h4>
      <p>You need to specify at least one reference to confirm your personality. You can also add more contacts in case you main reference is unavailable. For quick approval ensure that they are in touch.</p>
      <div id="ref_parent">
        <div class="reference">
          <b-form-select required v-model="ref" :options="refOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <label for>Status:</label>
          <b-form-select required v-model="status" :options="statOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Name" label-for="gname">
                <b-form-input id="gname" type="text" required placeholder="Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Phone Number" label-for="gnum">
                <b-form-input id="gnum" type="number" required placeholder="Number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-link class="addrel">
          <img src="@/assets/images/icons/plus.png" />Add relative or co-worker
        </b-link>
        <b-link class="addrel text-danger">
          <img src="@/assets/images/icons/minus.png" />Delete relative or co-worker
        </b-link>
      </div>
      <p
        class="mt-4"
      >For quick approval, please ensure their availability after your complete your application.</p>
      <div class="d-flex justify-content-end mb-4 next mt-4">
        <button @click.prevent="$router.push('/registration/step-4')" type="submit">Next Step</button>
      </div>
    </div>
    <div v-show="showPriv" class="em_form p-employee">
      <b-link @click="closePrivForm">Back to select</b-link>
      <h2 class="font-weight-bold mb-4 mt-2">Private Company Employee</h2>
      <b-form-group label="Company Name" label-for="pcname">
        <b-form-input id="pcname" type="text" required placeholder="Name"></b-form-input>
      </b-form-group>
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Company Phone" label-for="pphone">
            <b-form-input id="pphone" type="number" required placeholder="Phone"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6">
          <b-form-group label="Amount of the monthly income" label-for="pincome">
            <b-form-input id="pincome" type="number" required placeholder="Income"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <h4 class="mt-4">References</h4>
      <p>You need to specify at least one reference to confirm your personality. You can also add more contacts in case you main reference is unavailable. For quick approval ensure that they are in touch.</p>
      <div id="ref_parent">
        <div class="reference">
          <b-form-select required v-model="ref" :options="refOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <label for>Status:</label>
          <b-form-select required v-model="status" :options="statOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Name" label-for="pname">
                <b-form-input id="pname" type="text" required placeholder="Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Phone Number" label-for="pnum">
                <b-form-input id="pnum" type="number" required placeholder="Number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-link class="addrel">
          <img src="@/assets/images/icons/plus.png" />Add relative or co-worker
        </b-link>
        <b-link class="addrel text-danger">
          <img src="@/assets/images/icons/minus.png" />Delete relative or co-worker
        </b-link>
      </div>
      <p
        class="mt-4"
      >For quick approval, please ensure their availability after your complete your application.</p>
      <div class="d-flex justify-content-end mb-4 next mt-4">
        <button @click.prevent="$router.push('/registration/step-4')" type="submit">Next Step</button>
      </div>
    </div>
    <div v-show="showUnem" class="em_form unemployed">
      <b-link @click="closeUnemForm">Back to select</b-link>
      <h2 class="font-weight-bold mb-4 mt-2">Unemployed / Housewife</h2>
      <b-form-group label="Amount of the monthly income" label-for="unemincome">
        <b-form-input id="unemincome" type="number" required placeholder="Income"></b-form-input>
      </b-form-group>
      <h4 class="mt-4">References</h4>
      <p>You need to specify at least one reference to confirm your personality. You can also add more contacts in case you main reference is unavailable. For quick approval ensure that they are in touch.</p>
      <div id="ref_parent">
        <div class="reference">
          <b-form-select required v-model="ref" :options="refOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <label for>Status:</label>
          <b-form-select required v-model="status" :options="statOptions">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
            </template>
          </b-form-select>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Name" label-for="unem-name">
                <b-form-input id="unem-name" type="text" required placeholder="Name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Phone Number" label-for="unemnum">
                <b-form-input id="unemnum" type="number" required placeholder="Number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-link class="addrel">
          <img src="@/assets/images/icons/plus.png" />Add relative or co-worker
        </b-link>
        <b-link class="addrel text-danger">
          <img src="@/assets/images/icons/minus.png" />Delete relative or co-worker
        </b-link>
      </div>
      <p
        class="mt-4"
      >For quick approval, please ensure their availability after your complete your application.</p>
      <div class="d-flex justify-content-end mb-4 next mt-4">
        <button @click.prevent="$router.push('/registration/step-4')" type="submit">Next Step</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 1,
      showCall: false,
      showFree: false,
      showGov: false,
      showPriv: false,
      showUnem: false,
      ref: null,
      refOptions: [
        { value: "a", text: "Co-Worker" },
        { value: "b", text: "Relative" }
      ],
      status: null,
      statOptions: [
        { value: "a", text: "wife/husband" },
        { value: "b", text: "mother/father" },
        { value: "c", text: "brother/sister" },
        { value: "d", text: "uncle/aunt" },
        { value: "e", text: "son/daughter" },
        { value: "f", text: "other/friends" }
      ],
      references: [
        {
          referenceNameId: "refName1",
          referencePhoneId: "refPhone1"
        }
      ],
      employList: [
        {
          formCall: "showCallForm",
          title: "Call Center Employee"
        },
        {
          formCall: "showFreeForm",
          title: "Freelancer / Self-employed / Business Owner"
        },
        {
          formCall: "showGovForm",
          title: "Government Employee"
        },
        {
          formCall: "showPrivForm",
          title: "Private Company Employee"
        },
        {
          formCall: "showUnemForm",
          title: "Unemployed / Housewife"
        }
      ]
    };
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    showCallForm() {
      this.showCall = true;
    },
    closeCallForm() {
      this.showCall = false;
    },
    showFreeForm() {
      this.showFree = true;
    },
    closeFreeForm() {
      this.showFree = false;
    },
    showGovForm() {
      this.showGov = true;
    },
    closeGovForm() {
      this.showGov = false;
    },
    showPrivForm() {
      this.showPriv = true;
    },
    closePrivForm() {
      this.showPriv = false;
    },
    showUnemForm() {
      this.showUnem = true;
    },
    closeUnemForm() {
      this.showUnem = false;
    },
    makeToast(variant = null) {
      this.$bvToast.toast("Your reference list is empty", {
        title: `Loan Reference`,
        variant: variant,
        solid: true
      });
    },
    addRef() {
      let newItem = {};
      this.index += 1;
      newItem.referenceNameId = "refName" + this.index;
      newItem.referencePhoneId = "refPhone" + this.index;
      this.references.push(newItem);
    },
    deleteRef() {
      this.references.pop();
      this.index -= 1;
      if (this.references.length === 0) {
        this.index = 0;
        this.makeToast("danger");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.employement_details {
  position: relative;
  min-height: 400px;
  .em_list {
    position: absolute;
    width: 100%;
    z-index: 2;
    .list-group-item {
      border: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      background: transparent;
      position: relative;
      cursor: pointer;
      padding-left: 0;
    }
    .list-group-item:after {
      content: ">";
      font-size: 20px;
      font-weight: 300;
      position: absolute;
      right: 5px;
    }
  }
  .em_form {
    background: #fff;
    padding: 20px;
    z-index: 4;
    position: relative;
    .reference {
      padding: 20px;
      margin-bottom: 10px;
      border-radius: 6px;
      background: $base-bgcolor-lightblue;
      border: 1px solid #d4e6fb;
    }
    .addrel {
      display: flex;
      align-items: center;
      max-width: 280px;
      text-align: center;
      justify-content: center;
      background: #eee;
      border-radius: 4px;
      padding: 4px 10px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
      text-decoration: none;
      margin-top: 10px;
      img {
        margin-right: 5px;
      }
    }
  }
}
</style>